import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Stock.scss';
import { StockInputSelector, setTriggerRefreshInput, setTriggerSave } from './reducers/StockInputReducer';
import StockInput from './StockInput';
import StockTable from './StockTable';
import StockDetailModal from './StockDetailModal';

let triggerHotkeyAlready = false;

const Stock: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);
    const StockInputViewData = useSelector(StockInputSelector);

    useEffect(() => {
        document.title = "Stock";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid container className="input-fields">
                    <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                        <StockInput></StockInput>
                    </div>
                </Grid>
                <Grid container className="datatable">
                    <StockTable></StockTable>
                </Grid>
            </Grid>
            <StockDetailModal></StockDetailModal>
        </>
    )
};

export default Stock;